/*eslint no-undef: "error"*/
<template>
  <div>
    <div class="marker">
      <ul class="rigth">
        <li>
          <a href="#!" v-side-nav:demo="nav" class="sizeA stroke">
            <i class="material-icons dp48 fa-3x">apps</i> <br>
            <span>Menu</span>
          </a>
        </li>
      </ul>
    </div>
    <div>
      <v-side-nav id="demo">
        <div class="container">
          <p>Cliente</p>
          <p class="range-field">
            <input type="text" v-model="cliente">
            <transition-group name="fade" tag="ul" class="Results" v-if="mostrarClientes">
              <li v-for="(item, index) in clientes" :key="index" @click="seleccionarCliente(item)">
                  <span>
                      <strong>{{ item.nombre  }}</strong><br>
                  </span>
              </li>
            </transition-group>
          </p>
          <p>Fecha Inicio</p>
          <p class="range-field">
            <input type="date" v-model="startDate">
          </p>
          <p>Fecha Fin</p>
          <p class="range-field">
            <input type="date" v-model="endDate">
          </p>
          <label for="select">Mensajeros</label>
          <v-select name="select"
            id="select"
            v-model="messengerSelected"
            select-text="Seleccionar Mensajero"
            :preselect-first="true"
            :items="messengers"
          ></v-select>
          <p>Entregas</p>
          <p class="range-field">
            <input type="number" min="1" v-model="minEntries">
          </p>
          <p for="regreso">Ida y Regreso</p>
          <div class="switch">
            <label>
              No
              <input type="checkbox" v-model="regreso">
              <span class="lever"></span>
              Si
            </label>
          </div>
          <br>
          <button @click="generarReporte" style="width: 100%;" class="btn btn-block btn-info" type="submit">Generar</button>
          <br><br>
          <div class="center-align" v-if="mostrarLoader">
            <img class="responsive-img" src="../assets/loader.gif"/>
          </div>
          <div class="row" v-if="mostrarTabla">
            <p><strong>Total Servicios: </strong>{{ muestras.length }}</p>
            <p><strong>Eficiencia (media): </strong>{{ parseFloat(grandTotal).toFixed(2) }}</p>
            <p><strong>Desviación Estandar: </strong>{{ parseFloat(devEst).toFixed(2) }}</p>
            <table>
              <thead>
                <tr>
                    <th class="center-align">Optimo</th>
                    <th class="center-align">Normal</th>
                    <th class="center-align">Deficiente</th>
                    <th class="center-align">Ineficiente</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="center-align">$ {{ formatNumber.new(optimo) }}</td>
                  <td class="center-align">$ {{ formatNumber.new(normal) }}</td>
                  <td class="center-align">$ {{ formatNumber.new(ineficiente) }}</td>
                  <td class="center-align">-</td>
                </tr>
                <tr>
                  <td class="center-align">$ {{ formatNumber.new(optimoEntrega) }}</td>
                  <td class="center-align">$ {{ formatNumber.new(normalEntrega) }}</td>
                  <td class="center-align">$ {{ formatNumber.new(ineficienteEntrega) }}</td>
                  <td class="center-align">-</td>
                </tr>
              </tbody>
            </table>
            <hr>
            <div class="row">
              <div class="col s3"><a v-for="(item, index) in serviciosOptimos" :key="item.id" v-if="index <= 15" :href="`https://my.guepardos.co/tracking/${ item.id }?nav=false`" target="_BLANK">{{ lastFive(item.id) }} <br></a></div>
              <div class="col s3"><a v-for="(item, index) in serviciosNormales" :key="item.id" v-if="index <= 15" :href="`https://my.guepardos.co/tracking/${ item.id }?nav=false`" target="_BLANK">{{ lastFive(item.id) }} <br></a></div>
              <div class="col s3"><a v-for="(item, index) in serviciosIneficientes" :key="item.id" v-if="index <= 15" :href="`https://my.guepardos.co/tracking/${ item.id }?nav=false`" target="_BLANK">{{ lastFive(item.id) }} <br></a></div>
              <div class="col s3"><a v-for="(item, index) in serviciosDeficientes" :key="item.id" v-if="index <= 15" :href="`https://my.guepardos.co/tracking/${ item.id }?nav=false`" target="_BLANK">{{ lastFive(item.id) }} <br></a></div>
            </div>
            <!-- <vue-json-to-csv 
              :json-data="csvData"
               :csv-title="'reporte-eficiencia'" >
              <button class="teal button__custom"> 
                <b>Descargar CSV</b> 
              </button>
            </vue-json-to-csv> -->
          </div>
        </div>
      </v-side-nav>
      <gmap-map :center="center" ref="mapEficiencia" :options="{streetViewControl: false}" :zoom="zoom" class="sinNav">
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" :content="infoContent" @closeclick="infoWinOpen=false"></gmap-info-window>
        <gmap-marker
        v-for="(m, i) in markers"
        :key="i"
        :position="m.position"
        :icon="m.icon"
        @click="toggleInfoWindow(m,i)"
        ></gmap-marker>
      </gmap-map>
    </div>
    <notifications group="foo" position="bottom left" />
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import VueJsonToCsv from 'vue-json-to-csv'
import router from '../router'
import moment from 'moment'
import axios from 'axios'
import _ from 'lodash'
import { loaded } from 'vue2-google-maps'
var jStat = require('jStat').jStat
export default {
  name: 'servicio',
  data () {
    return {
      nav: {
        edge: 'right'
      },
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      zoom: 13,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      mostrarClientes: false,
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().add(30, 'day').format('YYYY-MM-DD'),
      messengers: [],
      messengerSelected: null,
      minEntries: 1,
      filteredServices: [],
      eficiencias: [],
      grandTotal: 0,
      mostrarTabla: false,
      mostrarLoader: false,
      regreso: false,
      csvData: [],
      muestras: [],
      devEst: 0,
      optimo: 0,
      normal: 0,
      serviciosOptimos: [],
      serviciosNormales: [],
      serviciosIneficientes: [],
      serviciosDeficientes: [],
      clienteSeleccionado: null,
      limite: 15,
      ineficiente: 0,
      ineficienteEntrega: 0,
      optimoEntrega: 0,
      normalEntrega: 0,
      formatNumber: {
        separador: '.', // separador para los miles
        sepDecimal: ',', // separador para los decimales
        formatear (num) {
          num += ''
          let splitStr = num.split('.')
          let splitLeft = splitStr[0]
          let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : ''
          let regx = /(\d+)(\d{3})/
          while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2')
          }
          return this.simbol + splitLeft + splitRight
        },
        new (num, simbol) {
          this.simbol = simbol || ''
          return this.formatear(Math.round(num / 100) * 100)
        }
      },
      clientes: [],
      cliente: ''
    }
  },
  created () {
    axios.get('https://mensajeria.guepardos.co/api/v2/mensajerosEficiencia')
      .then(response => {
        this.messengers = response.data.map((item, index) => {
          return {
            text: item.nombre,
            id: item.id,
            value: index + 1
          }
        })
        this.messengers.unshift({
          text: 'Todos los mensajeros',
          id: '000000',
          value: 0
        })
      })
    loaded.then(() => {
      this.$refs.mapEficiencia.$mapCreated.then(() => {
        let src = 'https://storage.googleapis.com/gpds-geo-zonas/MunicipiosDelAreaMetro.kml'
        let kmlLayer = new google.maps.KmlLayer(src, {
          suppressInfoWindows: true,
          preserveViewport: true,
          map: this.$refs.mapEficiencia.$mapObject
        })
      })
    })
  },
  methods: {
    generarReporte () {
      this.mostrarTabla = false
      this.mostrarLoader = true
      if (this.clienteSeleccionado) {
        return this.consultarPorCliente()
      }
      this.$Progress.start()
      const sDate = moment(this.startDate).utc().toISOString()
      const eDate = moment(this.endDate).utc().toISOString()
      const objectQuery = {
        startDate: sDate,
        endDate: eDate
      }
      axios.post('https://mensajeria.guepardos.co/api/v2/serviciosEficiencia', objectQuery)
      .then(response => {
        if (!this.messengerSelected || this.messengerSelected === '000000') {
          this.filteredServices = response.data.filter(item => {
            if (item.tarifa) {
              if (item.tarifa.numEntregas) {
                if (item.tarifa.numEntregas === Number(this.minEntries) && item.idaVuelta === this.regreso) {
                  return item
                }
              }
            }
          })
          if (this.filteredServices.length < 30) {
            this.$Progress.finish()
            this.mostrarLoader = false
            this.errorBusqueda()
            return
          } else if (this.filteredServices.length >= 30 && this.filteredServices.length < 50) {
            this.pasanWarning()
          }
          return this.drawMarkers()
        }
        this.filteredServices = response.data.filter(item => item.mensajeroId === this.messengerSelected)
        this.filteredServices = response.data.filter(item => {
          if (item.tarifa) {
            if (item.tarifa.numEntregas) {
              if (item.tarifa.numEntregas === Number(this.minEntries) && item.idaVuelta === this.regreso) {
                return item
              }
            }
          }
        })
        if (this.filteredServices.length < 30) {
          this.$Progress.finish()
          this.mostrarLoader = false
          this.errorBusqueda()
          return
        } else if (this.filteredServices.length >= 30 && this.filteredServices.length < 50) {
          this.pasanWarning()
        }
        this.drawMarkers()
        this.$Progress.finish()
      })
      .catch(error => {
        console.log(error)
        this.mostrarLoader = false
        this.$Progress.finish()
      })
    },
    consultarPorCliente () {
      this.$Progress.start()
      axios.get(`http://localhost:3005/api/v2/serviciosEficiencia/${this.clienteSeleccionado.id}`)
      .then(response => {
        this.$Progress.finish()
        this.filteredServices = response.data
        const numEntregas = response.data.reduce((a, b) => {
          if (b.tarifa) {
            if (b.tarifa.numEntregas) {
              return a + b.tarifa.numEntregas
            }
          }
          return a
        }, 0)
        this.minEntries = Math.round(numEntregas / response.data.length)
        if (this.filteredServices.length < 30) {
          this.mostrarLoader = false
          this.errorBusqueda()
          return
        } else if (this.filteredServices.length >= 30 && this.filteredServices.length < 50) {
          this.pasanWarning()
        }
        return this.drawMarkers()
      })
    },
    async drawMarkers () {
      this.markers = []
      this.muestras = []
      if (this.minEntries === 1) {
        this.limite = 30
      }
      if (this.clienteSeleccionado) {
        this.limite = 10000
      }
      for (let index = 0; index < this.filteredServices.length; index++) {
        const servicio = this.filteredServices[index]
        servicio.total = 0
        if (servicio.tarifa.distancia) {
          servicio.total = servicio.tarifa.distancia / servicio.tarifa.numEntregas
          if (servicio.total <= this.limite && servicio.total > 1) {
            this.muestras.push(servicio.total)
          }
        }
        for (let indexEntrega = 0; indexEntrega < servicio.tarifa.numEntregas; indexEntrega++) {
          const entrega = servicio.fechaHoraEntregas[indexEntrega]
          if (entrega) {
            this.markers.push({
              position: {
                lat: parseFloat(entrega.coordenadas.latitude),
                lng: parseFloat(entrega.coordenadas.longitude)
              },
              id: servicio.id,
              infoText: `<strong>Nombre: </strong>${servicio.nombre}<br><strong>Fecha: </strong>${servicio.fecha}<br><strong>Eficiencia: </strong>${parseFloat(servicio.total).toFixed(2)} km`,
              icon: require('../assets/service.png')
            })
          }
        }
      }
      this.filteredServices = this.filteredServices.filter(item => item.total > 0)
      this.grandTotal = this.grandTotal / this.filteredServices.length
      this.grandTotal = parseFloat(this.grandTotal).toFixed(2)
      this.calcularPrecio()
    },
    async calcularPrecio () {
      console.log(this.muestras)
      this.grandTotal = jStat.median(this.muestras)
      this.devEst = jStat.stdev(this.muestras)
      this.devEst = parseFloat(this.devEst).toFixed(4)
      this.optimo = await this.calcularPrecioTabla(Number(this.grandTotal) - Number(this.devEst))
      this.normal = await this.calcularPrecioTabla(Number(this.grandTotal))
      this.ineficiente = await this.calcularPrecioTabla(Number(this.grandTotal) + Number(this.devEst))
      this.optimoEntrega = this.optimo / this.minEntries
      this.normalEntrega = this.normal / this.minEntries
      this.ineficienteEntrega = this.ineficiente / this.minEntries
      this.serviciosOptimos = this.filteredServices.filter(item => item.total < (Math.round(this.grandTotal) - Math.round(this.devEst)))
      this.serviciosNormales = this.filteredServices.filter(item => item.total > (Math.round(this.grandTotal) - Math.round(this.devEst)) && item.total <= (Math.round(this.grandTotal)))
      this.serviciosIneficientes = this.filteredServices.filter(item => item.total > Number(Math.round(this.grandTotal)))
      this.serviciosDeficientes = this.filteredServices.filter(item => item.total > Number(Math.round(this.grandTotal) + Math.round(this.devEst)))
      this.serviciosOptimos = this.serviciosOptimos.filter(item => item.fechaHoraEntregas.filter(o => !o.regreso).length === Number(this.minEntries))
      this.serviciosNormales = this.serviciosNormales.filter(item => item.fechaHoraEntregas.filter(o => !o.regreso).length === Number(this.minEntries))
      this.serviciosIneficientes = this.serviciosIneficientes.filter(item => item.fechaHoraEntregas.filter(o => !o.regreso).length === Number(this.minEntries))
      this.serviciosDeficientes = this.serviciosDeficientes.filter(item => item.fechaHoraEntregas.filter(o => !o.regreso).length === Number(this.minEntries))
      this.serviciosIneficientes = this.serviciosIneficientes.filter(item => item.total <= this.limite)
      this.mostrarLoader = false
      this.mostrarTabla = true
    },
    lastFive (str) {
      return str.slice(0, 5)
    },
    async calcularPrecioTabla (kilometros) {
      kilometros = Math.abs(kilometros)
      let totalKilometros = kilometros * Number(this.minEntries)
      totalKilometros = Math.round(totalKilometros)
      let valKil = await this.consultarValorKilometros(totalKilometros)
      valKil = valKil[0].valorKm * totalKilometros
      let valParadas = await this.consultarParadas(Number(this.minEntries))
      valParadas = valParadas[0].valorParada * Number(this.minEntries)
      let total = valKil + valParadas
      return total
    },
    consultarValorKilometros (km) {
      const kilometros = Math.round(km)
      return axios.get(`https://mensajeria.guepardos.co/api/v2/kilometrosValue/${kilometros}`)
        .then(response => response.data)
        .catch(error => error)
    },
    consultarParadas (parada) {
      return axios.get(`https://mensajeria.guepardos.co/api/v2/paradasValue/${parada}`)
        .then(response => {
          this.$Progress.finish()
          return response.data
        })
        .catch(error => error)
    },
    toggleInfoWindow (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },
    seleccionarCliente (item) {
      this.clienteSeleccionado = item
      this.cliente = item.nombre
      this.mostrarClientes = false
    }
  },
  watch: {
    cliente: _.debounce(function () {
      const obj = {
        nombre: this.cliente
      }
      if (!this.cliente) {
        this.clienteSeleccionado = null
        return
      }
      if (this.clienteSeleccionado) {
        if (this.clienteSeleccionado.nombre === this.cliente) {
          return
        }
      }
      axios.post('http://localhost:3005/api/v2/clientes', obj)
      .then(response => {
        this.clientes = []
        this.clientes = response.data
        if (this.clientes.length > 0) {
          this.mostrarClientes = true
        }
      })
      .catch(error => console.log(error.response))
    }, 1000)
  },
  components: {
    VueJsonToCsv
  },
  notifications: {
    errorBusqueda: {
      title: 'Su búsqueda arrojo muy pocos datos:',
      message: '-Por favor aumente el rango de fechas. \n  -Modifique el numero de entregas',
      type: 'error',
      timeout: 9000
    },
    pasanWarning: {
      title: 'Cantidad de datos muy precisos:',
      message: '-podria ser mejor aumentar el rango de fechas',
      type: 'info',
      timeout: 9000
    }
  }
}
</script>
<style>
.side-nav {
  position: fixed;
  width: 300px;
  left: 0;
  top: 0;
  margin: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  height: 100%;
  height: calc(100% + 60px);
  height: -moz-calc(100%);
  padding-bottom: 60px;
  background-color: #fff;
  z-index: 999;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  overflow-y: auto;
  will-change: transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateX(-105%);
  transform: translateX(-105%);
}
.marker {
  float: right;
  position: relative;
  padding-right: 5px;
  z-index: 1;
}
#demo {
  width: 500px;
}
.sizeA {
  color: #410099;
}
.gm-fullscreen-control {
  display: none;
}
.colorVerde {
    color: #5cb85c;
}
.conNav {
 height: 91vh;
}
.sinNav {
  height: 100vh;
}
.stroke {
  -webkit-text-stroke: 0.5px black;
  opacity: 0.8;
}
.purple.darken-4 {
    background-color: #410099 !important;
}
.labels{
    color: black;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
    width: 100px;
}
.estilotextarea {
  width:400px;
  height:100px;
  border: 1px solid rgb(35, 163, 150);
}
.Results {
    margin: 0;
    margin-top: -15px;
    padding: 0;
    width: 100%;
    text-align: left;
    position: absolute;
    z-index: 999;
  }
  .Results li {
    /* background-color: rgba(35, 163, 150, 0.9); */
    background-color: rgba(252, 254, 254, 0.9);
    margin: 0;
    padding-left: 10px;
    height: 50px;
    list-style: none;
    width: 100%;
    border-bottom: 1px solid #394e62;
    border-left: 1px solid #394e62;
    border-right: 1px solid #394e62;
    transition: ease-in-out 0.5s;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Eficiencia.vue?2294f471